import { getNetworkName } from '@/utils/network/getNetworkName'
import { Button } from '../common/button'
import { Checkbox } from '../common/checkbox'
import { Label } from '../common/label'
import { NetworkImage } from '../common/networkImage'
import { Popover, PopoverContent, PopoverList, PopoverTrigger } from '../common/popover'
import { ScrollArea } from '../common/scrollArea'
import { Separator } from '../common/separator'
import { ArrowIcon } from '../icons/arrow'

interface BenchmarkNetworksSelectProps {
  availableNetworks: string[]
  selectedNetworks: Set<string>
  onSelectedNetworksChange: (networks: Set<string>) => void
  showLabel?: boolean
}

export const BenchmarkNetworksSelect = ({
  availableNetworks,
  selectedNetworks,
  onSelectedNetworksChange,
  showLabel = true,
}: BenchmarkNetworksSelectProps) => {
  return (
    <Label className="cursor-pointer items-center gap-2">
      {showLabel && <span className="whitespace-nowrap text-sm">Selected networks</span>}
      <Popover modal>
        <PopoverTrigger asChild>
          <Button variant="input" className="group flex w-44 gap-2 px-3 text-left text-sm">
            <div className="flex w-full max-w-full items-center gap-2 truncate">
              {selectedNetworks.size === 0 ? (
                <span>None</span>
              ) : selectedNetworks.size === 1 ? (
                <>
                  <NetworkImage network={[...selectedNetworks][0]} className="size-6" />
                  <span className="max-w-full truncate first-letter:uppercase">
                    {getNetworkName([...selectedNetworks][0])}
                  </span>
                </>
              ) : (
                <span>{selectedNetworks.size} selected</span>
              )}
            </div>
            <div className="group-data-[state=open]:-scale-y-100 transition-transform">
              <ArrowIcon direction="down" size={24} />
            </div>
          </Button>
        </PopoverTrigger>
        <PopoverContent>
          <ScrollArea type="auto" className="h-60">
            <PopoverList>
              {availableNetworks.map((network) => {
                const isSelected = selectedNetworks.has(network)

                return (
                  <li key={network} className="group">
                    <Label className="w-full cursor-pointer gap-2 px-3 py-2">
                      <Checkbox
                        checked={isSelected}
                        onCheckedChange={(checked) =>
                          onSelectedNetworksChange(
                            new Set(
                              checked
                                ? [...selectedNetworks, network]
                                : [...selectedNetworks].filter((n) => n !== network)
                            )
                          )
                        }
                      />
                      <NetworkImage network={network} className="size-6" />
                      <span className="text-sm first-letter:uppercase">{getNetworkName(network)}</span>
                    </Label>
                    <Separator className="group-last:hidden" />
                  </li>
                )
              })}
            </PopoverList>
          </ScrollArea>
        </PopoverContent>
      </Popover>
    </Label>
  )
}
